module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box citic-box"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('div', {
    staticClass: "add-btn",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleEdit()
      }
    }
  }, [_vm._v("增加新成员")])], 1), _vm._v(" "), _c('div', [_c('el-input', {
    staticClass: "search",
    attrs: {
      "placeholder": "按人物姓名搜索",
      "type": "text",
      "width": "10%"
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "keywords"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "btn-search",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSearch
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn-search",
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v("删除")])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "人物列表",
      "name": "person"
    }
  }, [_c('person', {
    attrs: {
      "tableType": _vm.tableType,
      "tableData": _vm.topuserList,
      "tableLabel": _vm.tableLabel,
      "tableImg": _vm.tableImg
    },
    on: {
      "edit": _vm.handleEdit,
      "delete": _vm.handleDelete,
      "upSort": _vm.upSort,
      "downSort": _vm.downSort
    }
  }), _vm._v(" "), (_vm.topuserList.length) ? _c('div', {
    staticClass: "tip"
  }, [(_vm.currentPage === _vm.totalPage) ? _c('div', {
    staticClass: "load-more-btn",
    staticStyle: {
      "text-align": "center"
    },
    on: {
      "click": _vm.loadMore
    }
  }, [_vm._v("没有更多数据~~")]) : _c('div', {
    staticClass: "load-more-btn",
    staticStyle: {
      "text-align": "center",
      "font-size": "18px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.loadMore
    }
  }, [_vm._v("点击加载更多")])]) : _vm._e()], 1)], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-5fce76a0!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/person/person.vue
// module id = 464
// module chunks = 11